import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCurrentRoleContext, getMenuList } from './Menu';
import { canAccessPath } from './routeAccess';

/**
 * Blocks authenticated users from URLs that are not in their sidebar
 * (or a registered child of those sidebar pages).
 */
function RoleRoute({ children }) {
	const location = useLocation();
	const menu = getMenuList();
	const { roleName } = getCurrentRoleContext();

	if (!canAccessPath(location.pathname, menu)) {
		return (
			<Navigate
				to="/page-error-403"
				replace
				state={{ from: location, roleName }}
			/>
		);
	}

	return children;
}

export default RoleRoute;
